import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import EventBusService from 'cio/services/event-bus';
import EditController from 'cio/pods/layout/edit/controller';
import LayoutModel from 'cio/models/layout';
import Transition from '@ember/routing/-private/transition';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class EditRoute extends Route {
  @service router!: RouterService;
  @service eventBus!: EventBusService;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Edit',
      path: 'layout.edit',
    };
  }

  model() {
    return (this.modelFor('layout') as LayoutModel).reload();
  }

  setupController(controller: EditController, model: LayoutModel, transition: Transition) {
    super.setupController(controller, model, transition);

    this.confirmChanges.register(controller, this);
  }

  redirect(layout: LayoutModel) {
    if (layout.get('archived')) {
      return this.router.transitionTo('layout.index', layout);
    }

    return;
  }
}
